import React from "react";
import PropTypes from "prop-types";

const ServiceLink = ({ icon, title, url, port, serviceName, publicIp, isHealthy }) => {
  const href = isHealthy ? `http://${publicIp}:${port}${url}` : "#";
  const linkClass = `service-link ${isHealthy ? "" : "service-link-disabled"}`;

  return (
    <a
      href={href}
      target={isHealthy ? "_blank" : undefined}
      rel={isHealthy ? "noopener noreferrer" : undefined}
      className={linkClass}
      onClick={(e) => !isHealthy && e.preventDefault()}
      title={isHealthy ? `Open ${title}` : "Service is not running"}
    >
      <div className="service-link-icon">{icon}</div>
      <div className="service-link-content">
        <div className="service-link-title">{title}</div>
        <div className="service-link-url">
          :{port}
          {url}
        </div>
        {!isHealthy && <div className="service-status">⚠️ Not Running</div>}
      </div>
    </a>
  );
};

ServiceLink.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  port: PropTypes.number.isRequired,
  serviceName: PropTypes.string.isRequired,
  publicIp: PropTypes.string.isRequired,
  isHealthy: PropTypes.bool.isRequired,
};

export default ServiceLink;
